import { env } from "@/env";

export type Locale = "en" | "ru" | "pt";

export function getLocaleFromPathname(pathname: string): Locale {
  if (pathname.startsWith("/en")) {
    return "en";
  }
  if (pathname.startsWith("/ru")) {
    return "ru";
  }
  if (pathname.startsWith("/pt")) {
    return "pt";
  }

  return env.VITE_DEFAULT_LOCALE || "en";
}
